import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { refreshSession, type Role } from "@/lib/session";
import {
  OsSearch, OsTasks, OsActions, OsHealth, OsModuleMap,
} from "@/components/os/os-command-centre";

export const Route = createFileRoute("/os/")({
  ssr: false,
  beforeLoad: async () => {
    const session = await refreshSession();
    if (!session) throw redirect({ to: "/auth" });
    return { role: session.role as Role };
  },
  head: () => ({
    meta: [
      { title: "Makai OS — one view of everything" },
      {
        name: "description",
        content:
          "Makai OS connects every part of the platform: search everything, see your tasks, and act on suggestions that always explain themselves.",
      },
      { property: "og:title", content: "Makai OS — one view of everything" },
      {
        property: "og:description",
        content:
          "Search across lessons, homework and people, see one task list, and act on explained recommendations.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: OsPage,
});

function OsPage() {
  const { role } = Route.useRouteContext();

  return (
    <AppShell
      role={role}
      title="Makai OS"
      subtitle="Everything in Makai, working together."
    >
      <div className="space-y-6">
        <OsSearch />
        <div className="grid gap-6 lg:grid-cols-2">
          <OsTasks />
          <OsActions role={role} />
        </div>
        {role === "admin" && <OsHealth />}
        <OsModuleMap />
      </div>
    </AppShell>
  );
}
